var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cls from 'classnames';
export function Section(_a) {
    var { title, counter, className, children, dangerouslySetInnerHTML } = _a, props = __rest(_a, ["title", "counter", "className", "children", "dangerouslySetInnerHTML"]);
    const finalClassName = cls('WhSearch-Section', className);
    const counterElement = counter == null ? null : React.createElement("span", { className: "WhSearch-Section__headerCounter" },
        "(",
        counter,
        ")");
    return (React.createElement("section", Object.assign({ className: finalClassName }, props),
        React.createElement("header", { className: "WhSearch-Section__header" },
            React.createElement("span", { className: "WhSearch-Section__headerText" }, title),
            counterElement),
        React.createElement("div", { className: "WhSearch-Section__content", dangerouslySetInnerHTML: dangerouslySetInnerHTML }, children)));
}
//# sourceMappingURL=Section.js.map